<div [ngStyle]="contentStyle" class="pointer-events-none">
  <finxone-web-frontend-text
    [isUsingHtmlStructure]="pageConfig.isUsingHtmlStructure ?? true"
    [contentStyle]="contentStyle"
    [renderedContent]="renderedContent"
  ></finxone-web-frontend-text>

  <div *ngIf="useQuoteCountdown" class="w-100 text-center mt-1 expiry-counter">
    <span>Quote Expiring in:</span>
    <h2>00:{{ countdown }}</h2>
  </div>
</div>
